import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { variantStyleMapping } from '../styles';
import { fontStyles, fontWeights } from "../../../tokens/typography";
import { colors } from "../../../tokens/color";
import { getResponsiveStyleObject } from "../../../shared/utils/responsive/responsive";
function Heading(props) {
    const { variant = 'h1', weight, color, italic, underline, component, children, align, ref, ...other } = props;
    const Component = component || variant;
    return (_jsx(Component, { ref: ref, css: [
            variantStyleMapping[variant],
            getResponsiveStyleObject(color, (color) => ({ color: colors.text[color] })),
            getResponsiveStyleObject(weight, (weight) => ({ fontWeight: fontWeights[weight] })),
            getResponsiveStyleObject(align, (align) => ({ textAlign: align })),
            {
                fontStyle: italic ? fontStyles.italic : undefined,
                textDecoration: underline ? 'underline' : undefined,
            },
        ], ...other, children: children }));
}
/**
 * A component used to render headings
 */
export { Heading };
